import { query, request } from '@/utils/request';
import { getInvociceDetailInterface } from 'src/config/sceneEnum';

const urls = {
  // invoiceList: '/zlb/api/invoice/list', // 票据列表
  invoiceList: '/zlb/api/invoice/newList', // 票据列表
  invoiceType: '/zlb/api/invoice/type', // 票据类型
  // invoiceDetail: '/zlb/api/invoice/detailNew', // 发票详情
  invoiceDetail: '/zlb/api/invoice/detail-new', // 发票详情
  deleteInvoice: '/zlb/api/invoice/delete', // 删除发票
  editInvoice: '/zlb/api/invoice/edit', // 编辑发票
  asyncOcr: '/zlb/api/invoice/asyncOcr', // 异步ocr识别,返回TaskCode
  getOcrResultAndAuthenticity: '/zlb/api/invoice/getOcrResultAndAuthenticity', // 获取异步ocr识别并验真
  batchAuthenticity: '/zlb/api/invoice/batchAuthenticity', // 批量验真
  saveInvoice: '/zlb/api/invoice/saveAfterAuthenticity', // 保存发票
  // meetingTrainingInvoiceDetail: '/zlb/api/expense/expense-form/invoice/query', // 发票详情，查看发票已统一使用 detailNew 接口，可下掉此接口
};

export async function fetchInvoiceList(data) {
  return query(urls.invoiceList, { method: 'POST', data });
}

export async function fetchInvoiceType(data) {
  return query(urls.invoiceType, { method: 'POST', data });
}

export async function getInvoiceDetail(params, returnDefault = false) {
  return query(getInvociceDetailInterface(returnDefault), { params });
}

export async function deleteInvoice(params) {
  return query(`${urls.deleteInvoice}/${params}`, { method: 'PUT' });
}

export async function editInvoice(data) {
  return query(urls.editInvoice, { method: 'POST', data });
}

export async function batchAuthenticity(data) {
  return query(`${urls.batchAuthenticity}?platformInvoiceIds=${data}`, { method: 'POST' });
}

// 票据验真后保存
export async function saveInvoice(data) {
  return query(urls.saveInvoice, { method: 'POST', data });
}

// 异步ocr识别,返回TaskCode
export async function asyncOcr(data) {
  return query(urls.asyncOcr, { method: 'POST', data });
}

// 获取异步ocr识别并验真
export async function getOcrResultAndAuthenticity(code) {
  return query(`${urls.getOcrResultAndAuthenticity}?taskCode=${code}`, { method: 'GET' });
}

// 直接验证并保存
export async function onOcrResultAndAuthenticity(data) {
  return query('/zlb/api/invoice/ocr-real-save', { method: 'POST', data });
}

// 获取手动录入发票类型
export async function fetchManualInvoiceList(data) {
  return query('/zlb/api/invoice/type/tree', { method: 'POST', data });
}

// 手动添加发票
export async function manualInvoiceSave(data) {
  return query('/zlb/api/invoice/manual-save', { method: 'POST', data });
}

// 刷新版式文件
export async function refreshInvocieFormatFile(params) {
  return query('/zlb/api/invoice/format-thumbnail-refresh', { params });
}

// 票据类型简化分类
export async function getInvoiceSimpleType(params) {
  return query('/zlb/api/invoice/invoiceSimpleType', { params });
}

// 根据条件获取票据类型
export async function getInvoiceType(data) {
  return query('/zlb/api/invoice/type', { method: 'POST', data });
}

// 根据条件获取票据类型
export async function getInvoiceTypeTree(data) {
  return query('/zlb/api/invoice/type/tree', { method: 'POST', data });
}

// 根据条件获取票据类型
export async function transferInvoice(data) {
  return query('/zlb/api/invoice/manage/batch/transfer', { method: 'POST', data });
}

// pc端个人票夹发票列表查询接口
export async function getPcInvoiceList(data) {
  return query('/zlb/api/invoice/pc/newList', { method: 'POST', data });
}

// 异常邮件发票附件列表
export function getErrorInvoiceList(data) {
  return query('/zlb/api/invoice/mail/attachment/list', { method: 'POST', data });
}

// 删除异常发票
export function delErrorInvoice(data) {
  return query('/zlb/api/invoice/delete/mail/attachment', { method: 'POST', data });
}

// 更新绑定发票
export function relateErrorInvoice(data) {
  return query('/zlb/api/invoice/refresh/mail/attachment/relation', { method: 'POST', data });
}

// 外省财政票 票据附件查询
export function getOtherProvincesInvoiceDetail(data) {
  return query('/zlb/api/invoice/cross/pro/detail', { method: 'POST', data });
}

// 外省财政票 开通省份配置
export async function queryOtherProvincesConfig(params) {
  return query('/zlb/api/invoice/cross/pro/config', {
    method: 'GET',
    params,
  });
}

// 外省财政票 查询列表查询接口
export async function requestOtherProvincesInvoiceList(data) {
  return request('/zlb/api/invoice/cross/pro/finance/list', {
    method: 'POST',
    data,
  });
}
